"use client";

import { useEffect } from "react";

export default function MarketingError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[MarketingError]", error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-21 py-55 text-center">
      <p className="text-xs font-semibold uppercase tracking-widest text-gold-ink">
        Something went wrong
      </p>
      <h2 className="mt-13 font-serif text-3xl uppercase leading-tight text-navy">
        Page <em className="not-italic">Error</em>
      </h2>
      <p className="mx-auto mt-13 max-w-sm text-sm leading-relaxed text-gray-600">
        We couldn&apos;t load this page. Please try again.
      </p>
      {error.digest && (
        <p className="mt-8 font-mono text-xs text-gray-500">
          ID: {error.digest}
        </p>
      )}
      <button
        onClick={reset}
        className="mt-34 rounded-control bg-gold px-21 py-13 text-sm font-semibold uppercase tracking-[0.04em] text-navy transition-colors hover:bg-gold-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold"
      >
        Try again
      </button>
    </div>
  );
}
